

export const frontMatter = {};
export const contentTitle = 'Please wait';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-pages/default/site-src-pages-501-mdx-e8f.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h1: "h1",
    header: "header",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "please-wait",
        children: "Please wait"
      })
    }), "\n", _jsx(_components.p, {
      children: "This article is not ready yet for your contribution – we're working on its source code in Markdown."
    }), "\n", _jsx(_components.p, {
      children: "Please come back later or take part in the translation of the previous (earlier) articles."
    }), "\n", _jsx(_components.p, {
      children: "Here's the progress of Markdown refinement, where you can see which articles are ready for your contribution:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "https://github.com/medzuslovjansky/medzuslovjansky.github.io/issues/45",
        children: "https://github.com/medzuslovjansky/medzuslovjansky.github.io/issues/45"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}

